module.exports = __webpack_public_path__ + "static/media/ic-cancel.cd852c93.svg";